module.exports = __webpack_public_path__ + "img/rpa1.c4e98df9.png";